// @flow
import type {Component, FormattedGrid} from '../entities'

export default function parseRawGrid (rawGrid:string, allComponents:Component[] ):FormattedGrid {
    const offsetX = 2
    const offsetY = 1
    if(!rawGrid) {
        rawGrid = `
            "  .   .   .   .  " auto
            / 1fr 1fr 1fr 1fr
        `
    }
    const componentsDict = allComponents.reduce((p,n) => (p[n.props.gridArea]={
        gridName: n.props.gridArea,
        id: n.id
    }) && p, {})
    const grid = {}
    const cluster = rawGrid.split('\n')
        .filter(s => s.replace(/\s+/g, ''))
        .slice(0, -1)
        .map(s => s.split('"')[1])
        .map(s => s.split(/\s+/).filter(_ => _))

    const getWidth = (x,y,g) => g[y].filter(n => n === g[y][x]).length
    const getHeight = (x,y,g) => g.map((_,i) => g[i][x]).filter(n => n === g[y][x]).length

    for(let x=0;x<(cluster[0] || []).length;x++){
        for(let y=0;y<cluster.length;y++){
            const gridName = cluster[y][x]
            if(!grid[gridName] && gridName !== '.'){
                const w = getWidth(x,y, cluster)
                const h = getHeight(x,y, cluster)
                const component = componentsDict[gridName] || { gridName, id: null }
                grid[gridName] = {
                    x: x+offsetX, 
                    y: y+offsetY, 
                    w, 
                    h,
                    component,
                    wasRemoved: Boolean(!componentsDict[gridName])
                }
            }
        }
    }

    return {
        widths: rawGrid.split('/')[1].split(/\s+/).filter(_ => _),
        heights: rawGrid.split('\n').filter(s => s.replace(/\s+/g, '')).slice(0, -1).map(s => s.split('"')[2].replace(/\s+/g, '')),
        components: Object.keys(grid).map(id => grid[id]),
        buffer: allComponents.filter(comp => !grid[comp.props.gridArea]).map(row => ({gridName: row.props.gridArea, id: row.id}))
    }
}


// WEBPACK FOOTER //
// ./src/utils/parseRawGrid.js